import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { DirectivesModule } from "../../directives/directives.module";
import { PipesModule } from "../../pipes/pipes.module";
import { PropertyListComponent } from "./property-list.component";

@NgModule({
  declarations: [PropertyListComponent],
  imports: [CoreModule, DirectivesModule, PipesModule],
  exports: [PropertyListComponent],
})
export class PropertyListModule {}
